import React from 'react';
import PurchasedCourseManagement from "../course/PurchasedCourseManagement";

const SellManagementCourseTab = () => {
    return (
        <>
            <PurchasedCourseManagement />
        </>
    );
};

export default SellManagementCourseTab;
